// Generated by Avo VERSION 183.8.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "b3vPhOWvbqN76ZZbkMdY";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "6akCpnlbHDBBbKoM0D3o",
          "br": "master",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "y2SHUZNik2PGrEQcBooS",
          "se": (new Date()).toISOString(),
          "so": "DgB_BDuzj",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "6akCpnlbHDBBbKoM0D3o",
          "br": "master",
          "en": env,
          "ty": type,
          "sc": "y2SHUZNik2PGrEQcBooS",
          "se": (new Date()).toISOString(),
          "so": "DgB_BDuzj",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "y2SHUZNik2PGrEQcBooS",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export interface Products {
  currency: string
  price: number
  quantity: number
  sku: string
  variant: string
  category: string
  position: number
  productName: string
  productType: string | null | undefined
  upsell: boolean
  productId: string
}

export const NavigationType = {
  'MAIN': 'main',
  'SUB': 'sub',
  'SHOP': 'shop',
  'IMAGE': 'image',
} as const;
export type NavigationTypeType = typeof NavigationType;
export type NavigationTypeValueType = NavigationTypeType[keyof NavigationTypeType];

export const SiteId = {
  'PRESONUS_SHOP': 'presonus_shop',
} as const;
export type SiteIdType = typeof SiteId;
export type SiteIdValueType = SiteIdType[keyof SiteIdType];

let sysDeviceCategory: any;
let sysSiteId: any;
let sysMarketId: any;

export function setSystemProperties(properties: {deviceCategory: string;
    siteId: SiteIdValueType;
    marketId: string}) {
  if (properties.deviceCategory !== null && properties.deviceCategory !== undefined) {
    sysDeviceCategory = properties.deviceCategory;
  }
  if (properties.siteId !== null && properties.siteId !== undefined) {
    sysSiteId = properties.siteId;
  }
  if (properties.marketId !== null && properties.marketId !== undefined) {
    sysMarketId = properties.marketId;
  }
}

let Segment: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    systemProperties: {deviceCategory: string;
    siteId: SiteIdValueType;
    marketId: string},
    destinationOptions: any,
    SegmentDestination: CustomDestination) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn("[avo] ****************************************************");
    InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
    InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
    InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
    InternalAvoLogger.warn("[avo] ****************************************************");
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log("[avo] ****************************************************");
    InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
    InternalAvoLogger.log("[avo] - No events will be sent");
    InternalAvoLogger.log("[avo] - No network requests are made");
    InternalAvoLogger.log("[avo] ****************************************************");
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
  }
  
  setSystemProperties(systemProperties);
  
  destinationOptions = destinationOptions || {};
  
  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
    
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }
    
    Segment = SegmentDestination;
    if (__AVO_ENV__ === 'prod') {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    } else if (__AVO_ENV__ === 'dev') {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    } else {
      console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Segment. Head to destination settings in Avo to set a staging key.");
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

function assertProducts(products: Products[],
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertList("TrwYfOMSg3", "products", products));
  if (products !== null && products !== undefined && products.forEach) {
    products.forEach(function (value, index) {
      messages = messages.concat(AvoAssert.assertObject("TrwYfOMSg3", "item at index " + index + " in products", value));
    });
  }
  return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface LoadedAPageProperties {
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
  customDestinationPageName_: string;
}
/**
 * Loaded a Page: This page is triggered whenever a user load a page without an event name on the website. This helps understand user engagement and monitor page performance
 * 
 * @param properties the properties associatied with this event
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * @param properties.customDestinationPageName_: Name of the page or screen
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/KyMgJwIB5T}
 */
export function loadedAPage(properties: LoadedAPageProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "KyMgJwIB5T", "f4c92a36656a176bab06c7ecea2236fb5ec05d5fd54ecfc66448839a5d82693c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Loaded a Page", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("KyMgJwIB5T", "Loaded a Page", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    // destination Segment
    if (Segment.logPage) {
      Segment.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface CartViewedProperties {
  products: Products[];
  total: number;
  subtotal: number;
  currency: string;
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
}
/**
 * Cart Viewed: This event fires when a user views their shopping cart
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/g0J95jPOW5/trigger/26nxoX1iA
 * 
 * @param properties the properties associatied with this event
 * @param properties.products: This array covers the products displayed in the product list
 * @param properties.total: This property indicates the revenue with discounts and coupons added (e.g: 731.16)
 * @param properties.subtotal: This property indicates the total after discounts but before taxes and shipping costs
 * @param properties.currency: This property indicates the currency of the transaction, which is represented by an uppercase three-letter acronym. (e.g: USD, EUR, GBP).
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/g0J95jPOW5}
 */
export function cartViewed(properties: CartViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "TrwYfOMSg3", name: "products", value: properties.products.map(function(value) { return {
      "currency": value.currency,
      "price": value.price,
      "quantity": value.quantity,
      "sku": value.sku,
      "variant": value.variant,
      "category": value.category,
      "position": value.position,
      "product_name": value.productName,
      "product_type": value.productType,
      "upsell": value.upsell,
      "product_id": value.productId,
    }
  })});
  eventPropertiesArray.push({id: "Vx39JxrRNl", name: "total", value: properties.total});
  eventPropertiesArray.push({id: "LcLsdcqUr2", name: "subtotal", value: properties.subtotal});
  eventPropertiesArray.push({id: "j8e3fLUmxT", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertProducts(properties.products));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "g0J95jPOW5", "25fd20f904fb5ef4c5bbd20f635e56ca60cbd697bd444aac3a5958da504c89a7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Cart Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("g0J95jPOW5", "Cart Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Cart Viewed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Cart Viewed", eventProperties, "g0J95jPOW5", "25fd20f904fb5ef4c5bbd20f635e56ca60cbd697bd444aac3a5958da504c89a7");
    }
    // destination Segment
    Segment.logEvent("Cart Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductAddedProperties {
  products: Products[];
  total: number;
  subtotal: number;
  currency: string;
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
  categoryTag: string[];
  source: string;
}
/**
 * Product Added: This event fires when a user adds a product to their shopping cart
 * 
 * @param properties the properties associatied with this event
 * @param properties.products: This array covers the products displayed in the product list
 * @param properties.total: This property indicates the revenue with discounts and coupons added (e.g: 731.16)
 * @param properties.subtotal: This property indicates the total after discounts but before taxes and shipping costs
 * @param properties.currency: This property indicates the currency of the transaction, which is represented by an uppercase three-letter acronym. (e.g: USD, EUR, GBP).
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * @param properties.categoryTag: This property indicate the list of tags associated with a product (i.e.: audiobox-series, interfaces, usb-audio-interfaces)
 * @param properties.source: This property specifies the source linked to the event, making it easier to categorize and track where items are added or removed from (e.g.: grid, mini-cart, heroModule, etc)
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/M1sj9G_Ecz}
 */
export function productAdded(properties: ProductAddedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "TrwYfOMSg3", name: "products", value: properties.products.map(function(value) { return {
      "currency": value.currency,
      "price": value.price,
      "quantity": value.quantity,
      "sku": value.sku,
      "variant": value.variant,
      "category": value.category,
      "position": value.position,
      "product_name": value.productName,
      "product_type": value.productType,
      "upsell": value.upsell,
      "product_id": value.productId,
    }
  })});
  eventPropertiesArray.push({id: "Vx39JxrRNl", name: "total", value: properties.total});
  eventPropertiesArray.push({id: "LcLsdcqUr2", name: "subtotal", value: properties.subtotal});
  eventPropertiesArray.push({id: "j8e3fLUmxT", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "hkL3YuKsP", name: "category_tag", value: properties.categoryTag});
  eventPropertiesArray.push({id: "g26RJUY2Vu", name: "source", value: properties.source});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertProducts(properties.products));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "M1sj9G_Ecz", "c249f315a330a8a47f1eed32ec11a41503befae005728285be6508d5a06d110b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Added", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("M1sj9G_Ecz", "Product Added", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Added': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Added", eventProperties, "M1sj9G_Ecz", "c249f315a330a8a47f1eed32ec11a41503befae005728285be6508d5a06d110b");
    }
    // destination Segment
    Segment.logEvent("Product Added", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NavigationClickedProperties {
  navigationGroup: string | null | undefined;
  navigationType: NavigationTypeValueType;
  navigationFlyout: string | null | undefined;
  navigationLabel: string;
  navigationCore: string;
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
}
/**
 * Navigation Clicked: This event fires when a user interacts with the navigation menu
 * 
 * When to trigger this event:
 * 1. In this example:
navigation_core = Shop
navigation_flyout = Studio Monitors
navigation_type = sub
navigation_label = Shop All
navigation_group = Eris Series
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/rIMgkey26m/trigger/pGIl9tTrF
 * 
 * @param properties the properties associatied with this event
 * @param properties.navigationGroup: This property indicates the label of the header text above the navigation item
 * @param properties.navigationType: This property indicates the type of navigation for this event, e.g. 'main', 'sub', 'shop', 'image'
 * @param properties.navigationFlyout: This property is the value of the top level navigation based on where a user clicked. For example on fender.com when a user clicks 'Electrics' -> Shop by Model -> Stratocaster, the value will be Electrics
 * @param properties.navigationLabel: This property indicates the verbiage in the selected link (e.g.: 'Audio Interfaces')
 * @param properties.navigationCore: This property indicates the description of the area the user chooses to navigate to
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/rIMgkey26m}
 */
export function navigationClicked(properties: NavigationClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.navigationGroup !== undefined && properties.navigationGroup !== null ?
    eventPropertiesArray.push({id: "pqLw1rtmE", name: "navigation_group", value: properties.navigationGroup}) :
    eventPropertiesArray.push({id: "pqLw1rtmE", name: "navigation_group", value: null});
  eventPropertiesArray.push({id: "FsudvlP-f", name: "navigation_type", value: properties.navigationType});
  properties.navigationFlyout !== undefined && properties.navigationFlyout !== null ?
    eventPropertiesArray.push({id: "gLWstWwnG", name: "navigation_flyout", value: properties.navigationFlyout}) :
    eventPropertiesArray.push({id: "gLWstWwnG", name: "navigation_flyout", value: null});
  eventPropertiesArray.push({id: "IFHI81WoK", name: "navigation_label", value: properties.navigationLabel});
  eventPropertiesArray.push({id: "FiFwktBL1s", name: "navigation_core", value: properties.navigationCore});
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "rIMgkey26m", "d946d191a54b31a77db5ccc594d949a41c361d41ce5c1a0d68f143a273989b95", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Navigation Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("rIMgkey26m", "Navigation Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Navigation Clicked", eventProperties, "rIMgkey26m", "d946d191a54b31a77db5ccc594d949a41c361d41ce5c1a0d68f143a273989b95");
    }
    // destination Segment
    Segment.logEvent("Navigation Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductViewedProperties {
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
  products: Products[];
  categoryTag: string[];
}
/**
 * Product Viewed: This event fires when a user views a product detail page (PDP)
 * 
 * When to trigger this event:
 * 1. This event fires when a user views a product detail page (PDP)

In this example we pull the products array:
price: 59.99
quantity: 1
product_id:
variant:
product_type
name: Eris 3.5 2nd Gen (Pair)
category: Studio Monitors
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/NRR_umZ0c1/trigger/2KocQRrFE
 * 2. This event fires as users click on the different variants. 
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/NRR_umZ0c1/trigger/vtc7GEuYW
 * 
 * @param properties the properties associatied with this event
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * @param properties.products: This array covers the products displayed in the product list
 * @param properties.categoryTag: This property indicate the list of tags associated with a product (i.e.: audiobox-series, interfaces, usb-audio-interfaces)
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/NRR_umZ0c1}
 */
export function productViewed(properties: ProductViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "TrwYfOMSg3", name: "products", value: properties.products.map(function(value) { return {
      "currency": value.currency,
      "price": value.price,
      "quantity": value.quantity,
      "sku": value.sku,
      "variant": value.variant,
      "category": value.category,
      "position": value.position,
      "product_name": value.productName,
      "product_type": value.productType,
      "upsell": value.upsell,
      "product_id": value.productId,
    }
  })});
  eventPropertiesArray.push({id: "hkL3YuKsP", name: "category_tag", value: properties.categoryTag});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertProducts(properties.products));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "NRR_umZ0c1", "e2b1cba10fb5971037b7ba7ac1075b0857e66538d5eab62bcf6ea7eccd165ce7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("NRR_umZ0c1", "Product Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Viewed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Viewed", eventProperties, "NRR_umZ0c1", "e2b1cba10fb5971037b7ba7ac1075b0857e66538d5eab62bcf6ea7eccd165ce7");
    }
    // destination Segment
    Segment.logEvent("Product Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductListViewedProperties {
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
  products: Products[];
  categoryTag: string[];
}
/**
 * Product List Viewed: This event fires when the user views a product list or category
 * 
 * When to trigger this event:
 * 1. This event fires when the user views a product list or category

In this example:
products = array of the products in view
category = [presonus-name-of-categories]
category_tag = Studio Monitors
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/eEVX4ABTXK/trigger/SxK-8vpmx
 * 
 * @param properties the properties associatied with this event
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * @param properties.products: This array covers the products displayed in the product list
 * @param properties.categoryTag: This property indicate the list of tags associated with a product (i.e.: audiobox-series, interfaces, usb-audio-interfaces)
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/eEVX4ABTXK}
 */
export function productListViewed(properties: ProductListViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "TrwYfOMSg3", name: "products", value: properties.products.map(function(value) { return {
      "currency": value.currency,
      "price": value.price,
      "quantity": value.quantity,
      "sku": value.sku,
      "variant": value.variant,
      "category": value.category,
      "position": value.position,
      "product_name": value.productName,
      "product_type": value.productType,
      "upsell": value.upsell,
      "product_id": value.productId,
    }
  })});
  eventPropertiesArray.push({id: "hkL3YuKsP", name: "category_tag", value: properties.categoryTag});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertProducts(properties.products));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "eEVX4ABTXK", "459e7c29d4368350097c63ed0184aaa447bd290097186d845252abaf1e061057", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product List Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("eEVX4ABTXK", "Product List Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product List Viewed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product List Viewed", eventProperties, "eEVX4ABTXK", "459e7c29d4368350097c63ed0184aaa447bd290097186d845252abaf1e061057");
    }
    // destination Segment
    Segment.logEvent("Product List Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DealerSearchedProperties {
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
  action: string;
  category: string | null | undefined;
  ctaText: string;
  position: number | null | undefined;
  ctaLocation: string | null | undefined;
  sku: string | null | undefined;
}
/**
 * Dealer Searched: This event fires when a user clicks to locate an authorized dealer by either clicking Find in Store or Find Online
 * 
 * When to trigger this event:
 * 1. This event fires when a user clicks to locate an authorized dealer by clicking the location icon on the top right side of the website to see Dealers and engages by either clicking Use My Location or enters a zip code and clicks search
action = Dealers
cta_text = search
cta_location = search
Or when a userclicks to see Distributors after selecting a specific region
action = Distributors
cta_text = view regions
cta_location Asia
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/uFYYqnKBy1/trigger/QgujJ-2Am
 * 2. This event fires when a user clicks to locate an authorized dealer by either clicking Find in Store or Find Online from a PDP
sku =8008508309699
category = Audio Interface
cta_text = Find In Store || Find Online
cta_location = PDP
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/uFYYqnKBy1/trigger/-lVk3hA-2
 * 3. This event fires when a user selects a particular dealer:
sku =8008508309699
not needed if fired from the location item on the top right side of our site. Needed if fired from a PDP
category = Audio Interface
optional if not from PDP
cta_text = PreSonus
position = 6
cta_location = PDP || Dealer Searched
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/uFYYqnKBy1/trigger/c7Be7a6xl
 * 4. This event fires when a user selects a particular dealer on the All Access Dealers from the Navigation option
cta_text = href
ideally,in the futre we'll change that to the actual text
position = 6
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/uFYYqnKBy1/trigger/Pv4XAWCm7
 * 
 * @param properties the properties associatied with this event
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * @param properties.action: This property indicates the action the user has taken
 * @param properties.category: This property indicates the category type this event is fired within (i.e.: Audio Interface)
 * @param properties.ctaText: This property inidicates the text displayed on the call to action button or link
 * @param properties.position: This property indicates the position of a product
 * @param properties.ctaLocation: This property indicates the location of the call to action on the page (e.g.: 'Hero Banner')
 * @param properties.sku: This property indicates the specific data field within the product listing. It holds the SKU also known as the stock keeping unit code assigned to the particular product variation selected
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/uFYYqnKBy1}
 */
export function dealerSearched(properties: DealerSearchedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "0kvxNYXra1", name: "action", value: properties.action});
  properties.category !== undefined && properties.category !== null ?
    eventPropertiesArray.push({id: "FghTgj0Eqe", name: "category", value: properties.category}) :
    eventPropertiesArray.push({id: "FghTgj0Eqe", name: "category", value: null});
  eventPropertiesArray.push({id: "uV956iaydS", name: "cta_text", value: properties.ctaText});
  properties.position !== undefined && properties.position !== null ?
    eventPropertiesArray.push({id: "5cZBB91CD_", name: "position", value: properties.position}) :
    eventPropertiesArray.push({id: "5cZBB91CD_", name: "position", value: null});
  properties.ctaLocation !== undefined && properties.ctaLocation !== null ?
    eventPropertiesArray.push({id: "Inf-weJdWQ", name: "cta_location", value: properties.ctaLocation}) :
    eventPropertiesArray.push({id: "Inf-weJdWQ", name: "cta_location", value: null});
  properties.sku !== undefined && properties.sku !== null ?
    eventPropertiesArray.push({id: "31XF3dQiYD", name: "sku", value: properties.sku}) :
    eventPropertiesArray.push({id: "31XF3dQiYD", name: "sku", value: null});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "uFYYqnKBy1", "c43ae8fb416aa110ddd2708306c3aa96d1bffad16ca815b95d85a8b399324784", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Dealer Searched", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("uFYYqnKBy1", "Dealer Searched", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Dealer Searched", eventProperties, "uFYYqnKBy1", "c43ae8fb416aa110ddd2708306c3aa96d1bffad16ca815b95d85a8b399324784");
    }
    // destination Segment
    Segment.logEvent("Dealer Searched", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductSearchedProperties {
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
  query: string;
  commonQuery: string;
}
/**
 * Product Searched: This event fires when a user clicks on a written search result
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/bBRzMc-kK0/trigger/UIEZ6tPt2
 * 
 * @param properties the properties associatied with this event
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * @param properties.query: This property indicates the search query or text that a user entered
 * @param properties.commonQuery: This property indicates the selected item or product clicked by a user after typing a query into the search string. When unable to match a suggestion, the result will be 'View All Products'
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/bBRzMc-kK0}
 */
export function productSearched(properties: ProductSearchedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "LtOQ4pWqFi", name: "query", value: properties.query});
  eventPropertiesArray.push({id: "SO79lQCQgj", name: "common_query", value: properties.commonQuery});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "bBRzMc-kK0", "4d69b536648650efc8ad78fb58f73b31bd5a3765f280af1245c716949df72d9e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Searched", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("bBRzMc-kK0", "Product Searched", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Searched", eventProperties, "bBRzMc-kK0", "4d69b536648650efc8ad78fb58f73b31bd5a3765f280af1245c716949df72d9e");
    }
    // destination Segment
    Segment.logEvent("Product Searched", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FileDownloadedProperties {
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
  userId_: string;
  sku: string;
  productName: string;
  category: string;
  ctaLocation: string;
  ctaText: string;
  shopifyId: string | null | undefined;
}
/**
 * File Downloaded: This event fires when a user initiates a file download
 * 
 * When to trigger this event:
 * 1. This property fires when a user initiates a download for a resource, installer, driver, or firmware from PreSonus Shop
sku: 2777500121
product_name: Eris 3.5 2nd Gen
category: studio-monitors
category_name: Studio Monitors
cta_location: Resources
cta_text: 2-year Limited Non-Transferable Warranty
(Installers/Drivers/Firmware) will also have downloadable content that needs to be captured in this type of event
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/wn374j_KgB/trigger/BSwEts6YO
 * 
 * @param properties the properties associatied with this event
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.sku: This property indicates the specific data field within the product listing. It holds the SKU also known as the stock keeping unit code assigned to the particular product variation selected
 * @param properties.productName: This property describes the name of a specific product
 * @param properties.category: This property indicates the category type this event is fired within (i.e.: Audio Interface)
 * @param properties.ctaLocation: This property indicates the location of the call to action on the page (e.g.: 'Hero Banner')
 * @param properties.ctaText: This property inidicates the text displayed on the call to action button or link
 * @param properties.shopifyId: Shopify's customer unique user ID is specific to each store. This means that if the same Shopify customer makes a purchase on Presonus.com and Fender.com, they will have different shopify_id because the stores are separate entities. Each Shopify store independently generates and manages its own customer IDs
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/wn374j_KgB}
 */
export function fileDownloaded(properties: FileDownloadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "31XF3dQiYD", name: "sku", value: properties.sku});
  eventPropertiesArray.push({id: "eTHbl1SL11", name: "product_name", value: properties.productName});
  eventPropertiesArray.push({id: "FghTgj0Eqe", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "Inf-weJdWQ", name: "cta_location", value: properties.ctaLocation});
  eventPropertiesArray.push({id: "uV956iaydS", name: "cta_text", value: properties.ctaText});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  properties.shopifyId !== undefined && properties.shopifyId !== null ?
    userPropertiesArray.push({id: "eZ7wJjei3", name: "shopify_id", value: properties.shopifyId}) :
    userPropertiesArray.push({id: "eZ7wJjei3", name: "shopify_id", value: null});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "wn374j_KgB", "4a5d20bc5030d6f4cac2383d797ffd6f503cbf0cb93e8859e32c4d028da2f92a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("File Downloaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("wn374j_KgB", "File Downloaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("File Downloaded", eventProperties, "wn374j_KgB", "4a5d20bc5030d6f4cac2383d797ffd6f503cbf0cb93e8859e32c4d028da2f92a");
    }
    // destination Segment
    Segment.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    Segment.logEvent("File Downloaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FileDownloadedPreSonusProperties {
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
  userId_: string;
  sku: string;
  productName: string;
  category: string;
  ctaLocation: string;
  ctaText: string;
  shopifyId: string | null | undefined;
  prsId: string;
}
/**
 * File Downloaded: This event fires when a user initiates a file download, event variant
 * 
 * @param properties the properties associatied with this event
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.sku: This property indicates the specific data field within the product listing. It holds the SKU also known as the stock keeping unit code assigned to the particular product variation selected
 * @param properties.productName: This property describes the name of a specific product
 * @param properties.category: This property indicates the category type this event is fired within (i.e.: Audio Interface)
 * @param properties.ctaLocation: This property indicates the location of the call to action on the page (e.g.: 'Hero Banner')
 * @param properties.ctaText: This property inidicates the text displayed on the call to action button or link
 * @param properties.shopifyId: Shopify's customer unique user ID is specific to each store. This means that if the same Shopify customer makes a purchase on Presonus.com and Fender.com, they will have different shopify_id because the stores are separate entities. Each Shopify store independently generates and manages its own customer IDs
 * @param properties.prsId: This user trait indicates the PreSonus user ID for users with a PreSonus user account.
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/wn374j_KgB.noGSk82Wp}
 */
export function fileDownloadedPresonus(properties: FileDownloadedPreSonusProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "31XF3dQiYD", name: "sku", value: properties.sku});
  eventPropertiesArray.push({id: "eTHbl1SL11", name: "product_name", value: properties.productName});
  eventPropertiesArray.push({id: "FghTgj0Eqe", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "Inf-weJdWQ", name: "cta_location", value: properties.ctaLocation});
  eventPropertiesArray.push({id: "uV956iaydS", name: "cta_text", value: properties.ctaText});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  properties.shopifyId !== undefined && properties.shopifyId !== null ?
    userPropertiesArray.push({id: "eZ7wJjei3", name: "shopify_id", value: properties.shopifyId}) :
    userPropertiesArray.push({id: "eZ7wJjei3", name: "shopify_id", value: null});
  userPropertiesArray.push({id: "d_Yq6Hfmvv", name: "prs_id", value: properties.prsId});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "wn374j_KgB.noGSk82Wp", "13efc1a3c6379f5bdcdb2532ab1f5c21d1d52b29a5bbd43f7fa172ebe4f38a56", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("File Downloaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("wn374j_KgB.noGSk82Wp", "File Downloaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("File Downloaded", eventProperties, "wn374j_KgB.noGSk82Wp", "13efc1a3c6379f5bdcdb2532ab1f5c21d1d52b29a5bbd43f7fa172ebe4f38a56");
    }
    // destination Segment
    Segment.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    Segment.logEvent("File Downloaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FilterClickedProperties {
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
  filterLabel: string;
  filterGroup: string;
  category: string;
}
/**
 * Filter Clicked: This event fires when a user clicks on a filtering UI on the Product List Pages (PLP)
 * 
 * When to trigger this event:
 * 1. This event fires when a user clicks on a filtering UI on the Product List Pages (PLP)
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/5txJyXVAMY/trigger/342s1tS8v
 * 
 * @param properties the properties associatied with this event
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * @param properties.filterLabel: This property describes the label being displayed to a user for the filter they're interacting with. Please avoid passing HTML or non-english wording.
 * @param properties.filterGroup: This property describes the header text displayed above the filter item the user is interacting with
 * @param properties.category: This property indicates the category type this event is fired within (i.e.: Audio Interface)
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/5txJyXVAMY}
 */
export function filterClicked(properties: FilterClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "2ePdiYjm_", name: "filter_label", value: properties.filterLabel});
  eventPropertiesArray.push({id: "koAYrwrHC", name: "filter_group", value: properties.filterGroup});
  eventPropertiesArray.push({id: "FghTgj0Eqe", name: "category", value: properties.category});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "5txJyXVAMY", "d81cc4a2e5d357dc911881b53d19ea6f26aa945a86b62ddd6ef8aebbe6473ab7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Filter Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("5txJyXVAMY", "Filter Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Filter Clicked", eventProperties, "5txJyXVAMY", "d81cc4a2e5d357dc911881b53d19ea6f26aa945a86b62ddd6ef8aebbe6473ab7");
    }
    // destination Segment
    Segment.logEvent("Filter Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PromotionClickedProperties {
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
  creative: string | null | undefined;
  position: number | null | undefined;
  ctaText: string;
  ctaLocation: string;
  ctaTargetUrl: string;
}
/**
 * Promotion Clicked: This event fires when a user clicks on a call-to-action (CTA) within an internal promotion that links to another part of the site. This event captures interactions like homepage, banners, or pop-ups that drive traffic to specific key areas (e.g.: Fender Play, Studio One Plus)
 * 
 * @param properties the properties associatied with this event
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * @param properties.creative: This property specifies the image URL information related to the creative used in this promotion.
 * @param properties.position: This property indicates the position of a product
 * @param properties.ctaText: This property inidicates the text displayed on the call to action button or link
 * @param properties.ctaLocation: This property indicates the location of the call to action on the page (e.g.: 'Hero Banner')
 * @param properties.ctaTargetUrl: This property indicates the destination link for the CTA
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/bts0KQcpCC}
 */
export function promotionClicked(properties: PromotionClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  properties.creative !== undefined && properties.creative !== null ?
    eventPropertiesArray.push({id: "O-nVddXgg", name: "creative", value: properties.creative}) :
    eventPropertiesArray.push({id: "O-nVddXgg", name: "creative", value: null});
  properties.position !== undefined && properties.position !== null ?
    eventPropertiesArray.push({id: "5cZBB91CD_", name: "position", value: properties.position}) :
    eventPropertiesArray.push({id: "5cZBB91CD_", name: "position", value: null});
  eventPropertiesArray.push({id: "uV956iaydS", name: "cta_text", value: properties.ctaText});
  eventPropertiesArray.push({id: "Inf-weJdWQ", name: "cta_location", value: properties.ctaLocation});
  eventPropertiesArray.push({id: "Ndc_rYxKF", name: "cta_target_url", value: properties.ctaTargetUrl});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "bts0KQcpCC", "1642c36848e6de45d4de6d3b72df07fc5e5bc6ed239438603e44a5bec4baecc2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Promotion Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("bts0KQcpCC", "Promotion Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Promotion Clicked", eventProperties, "bts0KQcpCC", "1642c36848e6de45d4de6d3b72df07fc5e5bc6ed239438603e44a5bec4baecc2");
    }
    // destination Segment
    Segment.logEvent("Promotion Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LoggedInProperties {
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
  userId_: string;
  shopifyId: string | null | undefined;
}
/**
 * Logged In: This event fires when the user either explicitly logs in, or is seen in the app again after time away
 * 
 * @param properties the properties associatied with this event
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.shopifyId: Shopify's customer unique user ID is specific to each store. This means that if the same Shopify customer makes a purchase on Presonus.com and Fender.com, they will have different shopify_id because the stores are separate entities. Each Shopify store independently generates and manages its own customer IDs
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/7BdZaxMo3p}
 */
export function loggedIn(properties: LoggedInProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  properties.shopifyId !== undefined && properties.shopifyId !== null ?
    userPropertiesArray.push({id: "eZ7wJjei3", name: "shopify_id", value: properties.shopifyId}) :
    userPropertiesArray.push({id: "eZ7wJjei3", name: "shopify_id", value: null});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "7BdZaxMo3p", "7e1afcde1596a3a11a855a86950847040734b8ddd44129d1679b18fb9a8c291b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Logged In", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("7BdZaxMo3p", "Logged In", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Logged In", eventProperties, "7BdZaxMo3p", "7e1afcde1596a3a11a855a86950847040734b8ddd44129d1679b18fb9a8c291b");
    }
    // destination Segment
    Segment.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    Segment.logEvent("Logged In", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LoggedInPreSonusProperties {
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
  userId_: string;
  shopifyId: string | null | undefined;
  prsId: string;
}
/**
 * Logged In: This event fires when the user either explicitly logs in, or is seen in the app again after time away, variant description: This event fires when a user successfully authenticates and gain access to their PreSonus account
 * 
 * When to trigger this event:
 * 1. This event fires when a user successfully authenticates or creates an account in PreSonus
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/7BdZaxMo3p.JL1ASyXFb/trigger/UkmBjRWWv
 * 
 * @param properties the properties associatied with this event
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.shopifyId: Shopify's customer unique user ID is specific to each store. This means that if the same Shopify customer makes a purchase on Presonus.com and Fender.com, they will have different shopify_id because the stores are separate entities. Each Shopify store independently generates and manages its own customer IDs
 * @param properties.prsId: This user trait indicates the PreSonus user ID for users with a PreSonus user account.
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/7BdZaxMo3p.JL1ASyXFb}
 */
export function loggedInPresonus(properties: LoggedInPreSonusProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  properties.shopifyId !== undefined && properties.shopifyId !== null ?
    userPropertiesArray.push({id: "eZ7wJjei3", name: "shopify_id", value: properties.shopifyId}) :
    userPropertiesArray.push({id: "eZ7wJjei3", name: "shopify_id", value: null});
  userPropertiesArray.push({id: "d_Yq6Hfmvv", name: "prs_id", value: properties.prsId});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "7BdZaxMo3p.JL1ASyXFb", "41bf92264e9d127aec80af35bc6a89230644b9420fa89378768799ca7294ecef", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Logged In", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("7BdZaxMo3p.JL1ASyXFb", "Logged In", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Logged In", eventProperties, "7BdZaxMo3p.JL1ASyXFb", "41bf92264e9d127aec80af35bc6a89230644b9420fa89378768799ca7294ecef");
    }
    // destination Segment
    Segment.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    Segment.logEvent("Logged In", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface RecommendationClickedProperties {
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
  position: number;
  productName: string | null | undefined;
  productType: string;
  sku: string | null | undefined;
  source: string;
  category: string;
  headerName: string | null | undefined;
}
/**
 * Recommendation Clicked: This event fires when the user clicks on a product specific recommendation
 * 
 * When to trigger this event:
 * 1. analytics.track('Recommendation Clicked', {
cta_location: 'wayfinding',
cta_text: 'Software',
header_name: 'Best Sellers'
  name: 'home',
  position: 1,
  product_name: 'PreSonus Studio One Pro',
  product_type: 'physical',
  sku: 'S778400304',
  source: 'productTile',
  category: 'Software',
  site_id: 'presonus_shop',
  device_category: 'desktop'
});
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/11QNaRu99t/trigger/EmjFcqmpk-
 * 
 * @param properties the properties associatied with this event
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * @param properties.position: This property indicates the position of a product
 * @param properties.productName: This property describes the name of a specific product
 * @param properties.productType: This property indicates whether a product is a digital or physical product
 * @param properties.sku: This property indicates the specific data field within the product listing. It holds the SKU also known as the stock keeping unit code assigned to the particular product variation selected
 * @param properties.source: This property specifies the source linked to the event, making it easier to categorize and track where items are added or removed from (e.g.: grid, mini-cart, heroModule, etc)
 * @param properties.category: This property indicates the category type this event is fired within (i.e.: Audio Interface)
 * @param properties.headerName: This property indicates the metadata name for any additional context name(e.g.: Best Sellers, Recording Favorites)
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/11QNaRu99t}
 */
export function recommendationClicked(properties: RecommendationClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "5cZBB91CD_", name: "position", value: properties.position});
  properties.productName !== undefined && properties.productName !== null ?
    eventPropertiesArray.push({id: "eTHbl1SL11", name: "product_name", value: properties.productName}) :
    eventPropertiesArray.push({id: "eTHbl1SL11", name: "product_name", value: null});
  eventPropertiesArray.push({id: "LaD2dTg03", name: "product_type", value: properties.productType});
  properties.sku !== undefined && properties.sku !== null ?
    eventPropertiesArray.push({id: "31XF3dQiYD", name: "sku", value: properties.sku}) :
    eventPropertiesArray.push({id: "31XF3dQiYD", name: "sku", value: null});
  eventPropertiesArray.push({id: "g26RJUY2Vu", name: "source", value: properties.source});
  eventPropertiesArray.push({id: "FghTgj0Eqe", name: "category", value: properties.category});
  properties.headerName !== undefined && properties.headerName !== null ?
    eventPropertiesArray.push({id: "mH9NPYzcO", name: "header_name", value: properties.headerName}) :
    eventPropertiesArray.push({id: "mH9NPYzcO", name: "header_name", value: null});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "11QNaRu99t", "b5e9b485a970ca40329508322cd93a18427624d4f321f6063a378617032fb016", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Recommendation Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("11QNaRu99t", "Recommendation Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Recommendation Clicked", eventProperties, "11QNaRu99t", "b5e9b485a970ca40329508322cd93a18427624d4f321f6063a378617032fb016");
    }
    // destination Segment
    Segment.logEvent("Recommendation Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LoggedOutProperties {
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
}
/**
 * Logged Out: This event fires when the user either explicitly logs out
 * 
 * @param properties the properties associatied with this event
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/CX2V-JJXfT}
 */
export function loggedOut(properties: LoggedOutProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "CX2V-JJXfT", "0d4eb9f5dd4823862e91d469148328f6744c30b033ad97830279c41b483e3346", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Logged Out", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("CX2V-JJXfT", "Logged Out", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Logged Out", eventProperties, "CX2V-JJXfT", "0d4eb9f5dd4823862e91d469148328f6744c30b033ad97830279c41b483e3346");
    }
    // destination Segment
    Segment.logEvent("Logged Out", (Object as any).assign({}, eventProperties));
    Segment.unidentify();
  } else {
    // do nothing
  }
}

export interface ProductRemovedProperties {
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
  products: Products[];
  total: number;
  subtotal: number;
  currency: string;
  source: string;
  categoryTag: string[];
}
/**
 * Product Removed: This event fires when a user removes a product from their shopping cart.
 * 
 * When to trigger this event:
 * 1. This event fires when a user removes an item from their shopping cart
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/rHApLvQV60/trigger/1HvGN-kYpq
 * 
 * @param properties the properties associatied with this event
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * @param properties.products: This array covers the products displayed in the product list
 * @param properties.total: This property indicates the revenue with discounts and coupons added (e.g: 731.16)
 * @param properties.subtotal: This property indicates the total after discounts but before taxes and shipping costs
 * @param properties.currency: This property indicates the currency of the transaction, which is represented by an uppercase three-letter acronym. (e.g: USD, EUR, GBP).
 * @param properties.source: This property specifies the source linked to the event, making it easier to categorize and track where items are added or removed from (e.g.: grid, mini-cart, heroModule, etc)
 * @param properties.categoryTag: This property indicate the list of tags associated with a product (i.e.: audiobox-series, interfaces, usb-audio-interfaces)
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/rHApLvQV60}
 */
export function productRemoved(properties: ProductRemovedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "TrwYfOMSg3", name: "products", value: properties.products.map(function(value) { return {
      "currency": value.currency,
      "price": value.price,
      "quantity": value.quantity,
      "sku": value.sku,
      "variant": value.variant,
      "category": value.category,
      "position": value.position,
      "product_name": value.productName,
      "product_type": value.productType,
      "upsell": value.upsell,
      "product_id": value.productId,
    }
  })});
  eventPropertiesArray.push({id: "Vx39JxrRNl", name: "total", value: properties.total});
  eventPropertiesArray.push({id: "LcLsdcqUr2", name: "subtotal", value: properties.subtotal});
  eventPropertiesArray.push({id: "j8e3fLUmxT", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "g26RJUY2Vu", name: "source", value: properties.source});
  eventPropertiesArray.push({id: "hkL3YuKsP", name: "category_tag", value: properties.categoryTag});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertProducts(properties.products));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "rHApLvQV60", "9afe599d34170020b65fa4f0234e9f279e02fd60dbfacb5b12cc89ecf3818797", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Removed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("rHApLvQV60", "Product Removed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Product Removed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Removed", eventProperties, "rHApLvQV60", "9afe599d34170020b65fa4f0234e9f279e02fd60dbfacb5b12cc89ecf3818797");
    }
    // destination Segment
    Segment.logEvent("Product Removed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NotifyInStockProperties {
  path: string;
  url: string;
  referrer: string;
  utmMedium: string | null | undefined;
  utmChannel: string | null | undefined;
  utmCampaign: string | null | undefined;
  date: string;
  utmSource: string | null | undefined;
  locale: string;
  name: string | null | undefined;
  sectionId: string;
  utmId: number | null | undefined;
  utmTerm: string | null | undefined;
  sourceCode: string | null | undefined;
  products: Products[];
  categoryTag: string[];
}
/**
 * Notify in Stock: This event fires whena user clicks to be notified about an out of stock product via email
 * 
 * When to trigger this event:
 * 1. This event fires when a user submits their information to be notified when an item will be available. This event does not track the PII shared with our organization
 * View in Avo: https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/nuuSQBgi8p/trigger/NVJ5ahmA7P
 * 
 * @param properties the properties associatied with this event
 * @param properties.path: This property indicates the path portion of the page's URL. This is equivalent to the canonical path from the DOM API (i.e.: /en/mixers/)
 * @param properties.url: This property indicates the current page's full URL
 * @param properties.referrer: This property indicates the previous page's full URL
 * @param properties.utmMedium: This property indicates the marketing medium: (e.g. cpc, banner, email) for use with Google
 * @param properties.utmChannel: This property indicates the rule-based groupings of the traffic source for use with Google (e.g: Organic, Email, Social, App)
 * @param properties.utmCampaign: This property indicates the product, promo code, slogan, or other campaign name for use with Google
 * @param properties.date: This property indicates the date in ISO 8601 date which formats date as Date('YYYY-MM-DD'). The year comes first, followed by the month and then by the day of the month (i.e: 2014-12-13)
 * @param properties.utmSource: This property indicates the referrer: (e.g. google, newsletter) for use with Google
 * @param properties.locale: This property indicates the user's geographical and linguistic preference (en_US) 
• Language: two-letter ISO639 code (e.g: 'en' for English) 
• Region: two-letter country code based on IEFT (e.g: 'US' for United States) If a language isn't region specific, use the 2-letter lowercase language representation 

Please note that the accuracy is not guaranteed as users can configure their devices differently
 * @param properties.name: This property indicates the name of a Page/Screen
 * @param properties.sectionId: This property indicates the section of the site the user is currently located. This allows us to segment user behavior by key site areas, such as shop funnel, resource center (blog), or a specific landing pages and flows
 * @param properties.utmId: This property identifies a unique campaign ID for tracking specific marketing efforts (e.g., 6684929587273) for use with Google
 * @param properties.utmTerm: This property identifies the paid search keyword or other defining term associated with the link (e.g., guitar, black-friday-deal, fender-stratocaster) for use with Google
 * @param properties.sourceCode: This property indicates the Shopify source code field and tracks attribution based on provenance (e.g: CRM, campaign, Fender Play)
 * @param properties.products: This array covers the products displayed in the product list
 * @param properties.categoryTag: This property indicate the list of tags associated with a product (i.e.: audiobox-series, interfaces, usb-audio-interfaces)
 * 
 * @see {@link https://www.avo.app/schemas/y2SHUZNik2PGrEQcBooS/events/nuuSQBgi8p}
 */
export function notifyInStock(properties: NotifyInStockProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "3T06W0aSN", name: "path", value: properties.path});
  eventPropertiesArray.push({id: "z4q8gr7Ob", name: "url", value: properties.url});
  eventPropertiesArray.push({id: "8NGzCV0on", name: "referrer", value: properties.referrer});
  properties.utmMedium !== undefined && properties.utmMedium !== null ?
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: properties.utmMedium}) :
    eventPropertiesArray.push({id: "lKooTUhNd", name: "utm_medium", value: null});
  properties.utmChannel !== undefined && properties.utmChannel !== null ?
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: properties.utmChannel}) :
    eventPropertiesArray.push({id: "1468h7k5j", name: "utm_channel", value: null});
  properties.utmCampaign !== undefined && properties.utmCampaign !== null ?
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: properties.utmCampaign}) :
    eventPropertiesArray.push({id: "VutEmJCR3", name: "utm_campaign", value: null});
  eventPropertiesArray.push({id: "kOCKbegpq", name: "date", value: properties.date});
  properties.utmSource !== undefined && properties.utmSource !== null ?
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: properties.utmSource}) :
    eventPropertiesArray.push({id: "41rDMkyQJ", name: "utm_source", value: null});
  eventPropertiesArray.push({id: "nblJcMdeF", name: "locale", value: properties.locale});
  properties.name !== undefined && properties.name !== null ?
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: properties.name}) :
    eventPropertiesArray.push({id: "bf3F55oXh", name: "name", value: null});
  eventPropertiesArray.push({id: "iCqia_ZxtKeqc1wQfjgut", name: "section_id", value: properties.sectionId});
  properties.utmId !== undefined && properties.utmId !== null ?
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: properties.utmId}) :
    eventPropertiesArray.push({id: "L0zzaR0YaYA1mux906evB", name: "utm_id", value: null});
  properties.utmTerm !== undefined && properties.utmTerm !== null ?
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: properties.utmTerm}) :
    eventPropertiesArray.push({id: "L_3M2FGGMplpZMgE6Ahrc", name: "utm_term", value: null});
  properties.sourceCode !== undefined && properties.sourceCode !== null ?
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: properties.sourceCode}) :
    eventPropertiesArray.push({id: "yIJ90IJf_", name: "source_code", value: null});
  eventPropertiesArray.push({id: "TrwYfOMSg3", name: "products", value: properties.products.map(function(value) { return {
      "currency": value.currency,
      "price": value.price,
      "quantity": value.quantity,
      "sku": value.sku,
      "variant": value.variant,
      "category": value.category,
      "position": value.position,
      "product_name": value.productName,
      "product_type": value.productType,
      "upsell": value.upsell,
      "product_id": value.productId,
    }
  })});
  eventPropertiesArray.push({id: "hkL3YuKsP", name: "category_tag", value: properties.categoryTag});
  eventPropertiesArray.push({id: "m11cixkqUX", name: "device_category", value: sysDeviceCategory});
  eventPropertiesArray.push({id: "c3yAq6HmUF", name: "site_id", value: sysSiteId});
  eventPropertiesArray.push({id: "MR1iY-5nqlYTlzsRYUcg7", name: "market_id", value: sysMarketId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertProducts(properties.products));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "nuuSQBgi8p", "b5c554e2d039468e19b8743c8930208c78dd3f4fbcfa31359970888931821308", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Notify in Stock", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("nuuSQBgi8p", "Notify in Stock", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Notify in Stock': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Notify in Stock", eventProperties, "nuuSQBgi8p", "b5c554e2d039468e19b8743c8930208c78dd3f4fbcfa31359970888931821308");
    }
    // destination Segment
    Segment.logEvent("Notify in Stock", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  NavigationType,
  SiteId,
  loadedAPage,
  cartViewed,
  productAdded,
  navigationClicked,
  productViewed,
  productListViewed,
  dealerSearched,
  productSearched,
  fileDownloaded,
  fileDownloadedPresonus,
  filterClicked,
  promotionClicked,
  loggedIn,
  loggedInPresonus,
  recommendationClicked,
  loggedOut,
  productRemoved,
  notifyInStock,
}

// AVOMODULEMAP:"PresonusAvo"
// AVOEVENTMAP:["loadedAPage","cartViewed","productAdded","navigationClicked","productViewed","productListViewed","dealerSearched","productSearched","fileDownloaded","fileDownloadedPresonus","filterClicked","promotionClicked","loggedIn","loggedInPresonus","recommendationClicked","loggedOut","productRemoved","notifyInStock"]
